/**
 * @generated SignedSource<<03e604ea9f2c08071e43ffca74ad393d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ActionItemLinkageModalRendererQuery$variables = {
  blockKey?: string | null;
  id?: string | null;
  noteId?: string | null;
};
export type ActionItemLinkageModalRendererQuery$data = {
  readonly noteBlock: {
    readonly " $fragmentSpreads": FragmentRefs<"ActionItemLinkageModalItem">;
  } | null;
};
export type ActionItemLinkageModalRendererQuery = {
  response: ActionItemLinkageModalRendererQuery$data;
  variables: ActionItemLinkageModalRendererQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "blockKey"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "noteId"
},
v3 = [
  {
    "kind": "Variable",
    "name": "blockKey",
    "variableName": "blockKey"
  },
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  },
  {
    "kind": "Variable",
    "name": "noteId",
    "variableName": "noteId"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasAccessToNote",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "note",
  "plural": false,
  "selections": [
    (v6/*: any*/),
    (v4/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "stream",
      "plural": false,
      "selections": [
        (v6/*: any*/),
        (v4/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isTodoStream",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "displayName",
          "storageKey": null
        },
        (v7/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "type",
              "storageKey": null
            }
          ],
          "type": "NoteStream",
          "abstractKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "NoteUser",
      "kind": "LinkedField",
      "name": "noteuserSet",
      "plural": true,
      "selections": [
        (v4/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": [
            (v4/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "fullName",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "NoteBlockConnection",
  "kind": "LinkedField",
  "name": "childBlocks",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "NoteBlockEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "NoteBlock",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v4/*: any*/),
            (v5/*: any*/),
            (v8/*: any*/),
            (v7/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ActionItemLinkageModalRendererQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "NoteBlock",
        "kind": "LinkedField",
        "name": "noteBlock",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ActionItemLinkageModalItem"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "ActionItemLinkageModalRendererQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "NoteBlock",
        "kind": "LinkedField",
        "name": "noteBlock",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "numNoAccess",
            "storageKey": null
          },
          (v5/*: any*/),
          (v8/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "NoteBlock",
            "kind": "LinkedField",
            "name": "originalBlock",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v7/*: any*/)
            ],
            "storageKey": null
          },
          (v9/*: any*/),
          (v7/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "2eec10a55910f34bd01ccba9a07f9673",
    "id": null,
    "metadata": {},
    "name": "ActionItemLinkageModalRendererQuery",
    "operationKind": "query",
    "text": "query ActionItemLinkageModalRendererQuery(\n  $id: ID\n  $blockKey: String\n  $noteId: ID\n) {\n  noteBlock(id: $id, blockKey: $blockKey, noteId: $noteId) {\n    ...ActionItemLinkageModalItem\n    id\n  }\n}\n\nfragment ActionItemLinkageModalItem on NoteBlock {\n  id\n  numNoAccess\n  hasAccessToNote\n  note {\n    __typename\n    id\n    stream {\n      __typename\n      id\n      isTodoStream\n    }\n  }\n  originalBlock {\n    id\n    hasAccessToNote\n    note {\n      __typename\n      id\n      stream {\n        __typename\n        id\n        isTodoStream\n      }\n    }\n    childBlocks {\n      edges {\n        node {\n          id\n          hasAccessToNote\n          note {\n            __typename\n            id\n            stream {\n              __typename\n              id\n              isTodoStream\n            }\n          }\n          ...ActionItemLinkageModalNoteInfo\n        }\n      }\n    }\n    ...ActionItemLinkageModalNoteInfo\n  }\n  childBlocks {\n    edges {\n      node {\n        id\n        hasAccessToNote\n        note {\n          __typename\n          id\n          stream {\n            __typename\n            id\n            isTodoStream\n          }\n        }\n        ...ActionItemLinkageModalNoteInfo\n      }\n    }\n  }\n  ...ActionItemLinkageModalNoteInfo\n}\n\nfragment ActionItemLinkageModalNoteInfo on NoteBlock {\n  id\n  url\n  note {\n    __typename\n    id\n    title\n    noteuserSet {\n      id\n      user {\n        id\n        fullName\n      }\n    }\n    stream {\n      __typename\n      id\n      displayName\n      url\n      ... on NoteStream {\n        type\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "8f4dcc34f25114a4f38140e91d9327cd";

export default node;
